// src/main/ExpenseCategory.js

import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import {
    Container,
    Typography,
    Button,
    Paper,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Box,
    Chip,
    Grid,
    Slide,
    MenuItem,
    InputLabel,
    FormControl,
    Select,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TablePagination,
    Divider,
    useTheme,
    InputAdornment,
    Menu,
    Tooltip,
    Card,
    CardContent,
    CardActions,
    Avatar,
    Tabs,
    Tab,
    Alert,
    Snackbar,
    FormControlLabel,
    Switch,
    CircularProgress,
    LinearProgress,
    Stepper,
    Step,
    StepLabel,
    Badge,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Rating,
    Fab,
    Zoom,
    Breadcrumbs,
    Link,
    StepConnector,
    stepConnectorClasses,
    styled,
    Timeline,
    TimelineItem,
    TimelineSeparator,
    TimelineDot,
    TimelineConnector,
    TimelineContent,
    TimelineOppositeContent,
    Checkbox,
    FormGroup,
    Radio,
    RadioGroup,
    FormLabel,
    TableFooter,
    SpeedDial,
    SpeedDialAction,
    SpeedDialIcon
} from '@mui/material';
import {
    Delete,
    Search,
    Add as AddIcon,
    Close as CloseIcon,
    Filter as FilterIcon,
    Refresh as RefreshIcon,
    Edit as EditIcon,
    Visibility as ViewIcon,
    PictureAsPdf,
    TableChart,
    GetApp,
    Print,
    CheckCircle,
    Cancel,
    People,
    AttachMoney,
    Email as EmailIcon,
    Send,
    Download,
    Receipt as ReceiptIcon,
    ReceiptLong,
    Pending,
    Error as ErrorIcon,
    Verified,
    Schedule,
    CloudDownload,
    LocalPrintshop,
    QrCodeScanner,
    History,
    CheckCircleOutline,
    Warning,
    Info,
    Phone,
    Person,
    Business,
    Home,
    CalendarToday,
    Description,
    Note,
    AttachFile,
    CloudUpload,
    AccountBalance,
    TrendingUp,
    TrendingDown,
    Calculate,
    Adjust,
    LocalAtm,
    MoneyOff,
    VerifiedUser,
    Balance,
    Receipt,
    EventNote,
    AssignmentInd,
    KeyboardArrowDown,
    KeyboardArrowUp,
    Summarize,
    MeetingRoom,
    Build,
    CleaningServices,
    HomeRepairService,
    AdsClick,
    Facebook,
    Google,
    Instagram,
    Twitter,
    Campaign,
    Visibility as VisibilityIcon,
    Assessment,
    Timeline as TimelineIcon,
    DateRange,
    Today,
    Weekend,
    BedroomParent,
    Bathroom,
    SquareFoot,
    LocationCity,
    Apartment,
    DoneAll,
    Clear,
    PlaylistAddCheck,
    Inventory,
    ReportProblem,
    Star,
    StarBorder,
    TrendingFlat,
    AccessTime,
    WatchLater,
    HourglassEmpty,
    MoveToInbox,
    CheckBox,
    RadioButtonChecked,
    TaskAlt,
    Handyman,
    Construction,
    Plumbing,
    ElectricalServices,
    AcUnit,
    LocalFireDepartment,
    PestControl,
    Lock,
    WaterDamage,
    Roofing,
    Window,
    DoorFront,
    Kitchen,
    LocalLaundryService,
    Security,
    Wifi,
    LocalParking,
    Elevator,
    Pool,
    FitnessCenter,
    AssignmentLate,
    CheckCircleOutline as CheckCircleOutlineIcon,
    HighlightOff,
    Engineering,
    MiscellaneousServices,
    Savings,
    AccountBalanceWallet,
    Payment,
    Receipt as ReceiptIconNew,
    Description as DescriptionIcon,
    NoteAdd,
    Calculate as CalculateIcon,
    TrendingUp as TrendingUpIcon,
    TrendingDown as TrendingDownIcon,
    CheckCircle as CheckCircleIcon,
    Cancel as CancelIcon,
    Pending as PendingIcon,
    HourglassEmpty as HourglassIcon,
    Money as MoneyIcon,
    Savings as SavingsIcon,
    AccountBalance as AccountBalanceIcon,
    LocalAtm as LocalAtmIcon,
    MonetizationOn,
    CurrencyExchange,
    PriceChange,
    PriceCheck,
    RequestQuote,
    ReceiptLong as ReceiptLongIcon,
    FactCheck,
    Rule,
    Checklist,
    Approval,
    ThumbUp,
    ThumbDown,
    Gavel,
    Shield,
    LockClock,
    Security as SecurityIcon,
    ExitToApp,
    DoorSliding,
    CleaningServices as CleaningIcon,
    Construction as ConstructionIcon,
    BugReport,
    WaterDrop,
    ElectricBolt,
    Kitchen as KitchenIcon,
    Weekend as WeekendIcon,
    Chair,
    Bed,
    Shower,
    Checkroom,
    Inventory as InventoryIcon,
    AssignmentTurnedIn,
    Summarize as SummarizeIcon,
    Receipt as ReceiptIconLong,
    Print as PrintIcon,
    PictureAsPdf as PdfIcon,
    Category,
    Label,
    LocalOffer,
    PriceCheck as PriceCheckIcon,
    TrendingUp as TrendingUpIconNew,
    BarChart,
    PieChart as PieChartIcon,
    ShowChart,
    Timeline as TimelineIconNew,
    Analytics,
    DataUsage,
    StackedBarChart,
    DonutLarge,
    Insights,
    Leaderboard,
    QueryStats,
    Assessment as AssessmentIcon,
    TableRows,
    GridOn,
    Storage,
    Dataset,
    DataObject,
    ScatterPlot,
    BubbleChart,
    MultilineChart,
    Money as MoneyIconNew,
    Paid,
    Payments,
    PriceChange as PriceChangeIcon,
    RequestPage,
    Receipt as ReceiptIconNew2,
    FactCheck as FactCheckIcon,
    Approval as ApprovalIcon,
    Task,
    Done,
    Close,
    Remove,
    Add,
    Edit,
    Save,
    CancelOutlined,
    Check,
    Clear as ClearIcon,
    FilterAlt,
    Sort,
    ViewAgenda,
    ViewCarousel,
    ViewColumn,
    ViewComfy,
    ViewCompact,
    ViewDay,
    ViewHeadline,
    ViewList,
    ViewModule,
    ViewQuilt,
    ViewSidebar,
    ViewStream,
    Web,
    WebAsset,
    WebStories,
    Widgets,
    Dashboard,
    TableChart as TableChartIcon,
    BubbleChart as BubbleChartIcon,
    DonutSmall,
    Timeline as TimelineIcon2,
    ShowChart as ShowChartIcon,
    ScatterPlot as ScatterPlotIcon,
    MultilineChart as MultilineChartIcon,
    StackedLineChart,
    AreaChart,
    BarChart as BarChartIcon,
    PieChart,
    Leaderboard as LeaderboardIcon,
    QueryStats as QueryStatsIcon,
    Insights as InsightsIcon,
    Analytics as AnalyticsIcon
} from '@mui/icons-material';
import { motion } from 'framer-motion';
import useCustomToast from '../../hooks/useToast';
import {
    APIExpenseCategoryList,
    APIExpenseCategoryStore,
    APIExpenseCategoryUpdate,
    APIExpenseCategoryDelete,
    APIExpenseCategoryExportExcel,
    APIExpenseCategoryExportPDF,
    APIExpenseCategoryPrint,
} from '../../apiServices/APIs';
import { formatCreatedAtDate, recordsCount, recordsPerPage } from '../../utils/helpers';
import { getUserDetails } from '../../utils/helpers';
import { apiService } from '../../apiServices/ApiService';
import ErrorState from '../../components/ErrorrState';
import LoadingState from '../../components/LoadingState';
import { usePermission } from '../../hooks/usePermission';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ExpenseCategory = () => {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const showToast = useCustomToast();
    const [updateId, setUpdateId] = useState('');
    const [postStatus, setPostStatus] = useState('ADD');
    const [exportAnchorEl, setExportAnchorEl] = useState(null);
    const [pageState, setPageState] = useState({
        pageData: [],
    });
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(recordsPerPage);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    // Use ref to track if component is mounted
    const isMounted = useRef(true);

    // Expense category options (enums)
    const categoryOptions = [
        { id: 'utilities', name: 'Utilities', icon: <ElectricalServices />, color: 'info', description: 'Water, electricity, gas, internet, etc.' },
        { id: 'maintenance', name: 'Maintenance & Repairs', icon: <Build />, color: 'warning', description: 'Regular maintenance, emergency repairs, etc.' },
        { id: 'cleaning', name: 'Cleaning & Janitorial', icon: <CleaningServices />, color: 'success', description: 'Common area cleaning, waste removal, etc.' },
        { id: 'property_tax', name: 'Property Tax', icon: <AccountBalance />, color: 'error', description: 'Annual property taxes' },
        { id: 'insurance', name: 'Insurance', icon: <Security />, color: 'primary', description: 'Property insurance premiums' },
        { id: 'marketing', name: 'Marketing & Advertising', icon: <Campaign />, color: 'secondary', description: 'Listing fees, advertising costs, etc.' },
        { id: 'legal', name: 'Legal & Professional', icon: <Gavel />, color: 'error', description: 'Legal fees, professional services' },
        { id: 'management', name: 'Property Management', icon: <Business />, color: 'info', description: 'Management fees, admin costs' },
        { id: 'renovation', name: 'Renovation & Improvement', icon: <Construction />, color: 'warning', description: 'Major renovations, capital improvements' },
        { id: 'supplies', name: 'Supplies & Materials', icon: <Inventory />, color: 'default', description: 'General supplies, materials, etc.' },
        { id: 'landscaping', name: 'Landscaping & Grounds', icon: <Weekend />, color: 'success', description: 'Gardening, lawn care, snow removal' },
        { id: 'security', name: 'Security Services', icon: <Security />, color: 'info', description: 'Security guards, surveillance systems' },
        { id: 'pest_control', name: 'Pest Control', icon: <BugReport />, color: 'warning', description: 'Regular pest control services' },
        { id: 'waste_management', name: 'Waste Management', icon: <Delete />, color: 'default', description: 'Trash collection, recycling' },
        { id: 'technology', name: 'Technology & Software', icon: <Storage />, color: 'primary', description: 'Software subscriptions, IT services' }
    ];

    // Form data for Expense Category
    const [formData, setFormData] = useState({
        category_name: '',
        budget_monthly: '',
        notes: '',
        is_active: true,
        color_code: '#3498db',
        icon_name: 'Category'
    });

    const [filters, setFilters] = useState({
        category_name: '',
        is_active: '',
        min_budget: '',
        max_budget: ''
    });

    const [errors, setErrors] = useState({
        category_name: false
    });

    // State for dialogs
    const [filterOptions, setFilterOptions] = useState(false);
    const [openAdd, setOpenAdd] = useState(false);
    const [openView, setOpenView] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

    const { hasPermission, loading: permissionLoading } = usePermission();

    useEffect(() => {
        isMounted.current = true;
        apiService.setToastFunction(showToast);
        fetchCategories();

        return () => {
            isMounted.current = false;
        };
    }, [showToast]);

    // Fetch expense categories
    const fetchCategories = async () => {
        setLoading(true);
        setError(null);
        try {
            const userBranchId = getUserDetails("branchId");
            const result = await apiService.list(userBranchId, APIExpenseCategoryList);

            if (result.success && isMounted.current) {
                const categories = Array.isArray(result.data) ? result.data.reverse() : [];
                setPageState(prev => ({
                    ...prev,
                    pageData: categories
                }));
            } else if (isMounted.current) {
                setError(result.message);
            }
        } catch (error) {
            if (isMounted.current) {
                setError("Failed to load data");
            }
            console.error("Fetch error:", error);
        } finally {
            if (isMounted.current) {
                setLoading(false);
            }
        }
    };


    // Export handlers
    const handleExportClick = (event) => { setExportAnchorEl(event.currentTarget); };
    const handleExportClose = () => { setExportAnchorEl(null); };
    
    const handlePrintCategory = async (record) => {
        if (!hasPermission('EXPORT')) {
            showToast("Permission Denied", "You don't have permission to print category details", "error");
            return;
        }
        
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('print_id', record.id);
            formDataToSend.append('user_name', getUserDetails("userName"));
            formDataToSend.append('branch_id', getUserDetails("branchId"));
            formDataToSend.append('user_id', getUserDetails("Id"));
            const result = await apiService.print(APIExpenseCategoryPrint, formDataToSend);
            if (result && result.success && isMounted.current) {
                showToast("Success", "PDF file generated successfully", "success");
            } else if (isMounted.current) {
                showToast("Error", result.message || "Failed to generate PDF file", "error");
            }
        } catch (error) {
            console.error("Print error:", error);
            if (isMounted.current) {
                showToast("Error", "Failed to generate PDF file", "error");
            }
        }
    };
    
    const handleExportExcel = async () => {
        if (!hasPermission('EXPORT')) {
            showToast("Permission Denied", "You don't have permission to export category data", "error");
            handleExportClose();
            return;
        }
        
        try {
            handleExportClose();
            showToast("Processing", "Preparing Excel export...", "info");
            const formDataToSend = new FormData();
            formDataToSend.append('branch_id', getUserDetails("branchId"));
            formDataToSend.append('user_id', getUserDetails("Id"));
            const result = await apiService.exportToExcel(APIExpenseCategoryExportExcel, formDataToSend);
            if (result && result.success && isMounted.current) {
                showToast("Success", "Excel file downloaded successfully", "success");
            } else if (isMounted.current) {
                showToast("Error", result.message || "Failed to export Excel file", "error");
            }
        } catch (error) {
            console.error('Excel export error:', error);
            if (isMounted.current) {
                showToast("Error", error.message || "Failed to export Excel file", "error");
            }
        }
    };

    const handleExportPDF = async () => {
        if (!hasPermission('EXPORT')) {
            showToast("Permission Denied", "You don't have permission to export category data", "error");
            handleExportClose();
            return;
        }
        
        try {
            handleExportClose();
            showToast("Processing", "Preparing PDF export...", "info");

            const formDataToSend = new FormData();
            formDataToSend.append('branch_id', getUserDetails("branchId"));
            formDataToSend.append('user_name', getUserDetails("userName"));
            formDataToSend.append('user_id', getUserDetails("Id"));
            const result = await apiService.exportToPDF(APIExpenseCategoryExportPDF, formDataToSend);

            if (result && result.success && isMounted.current) {
                showToast("Success", "PDF file downloaded successfully", "success");
            } else if (isMounted.current) {
                showToast("Error", result.message || "Failed to export PDF file", "error");
            }
        } catch (error) {
            console.error('PDF export error:', error);
            if (isMounted.current) {
                showToast("Error", error.message || "Failed to export PDF file", "error");
            }
        }
    };

    // Filter handlers
    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const clearFilters = () => {
        setFilters({
            category_name: '',
            is_active: '',
            min_budget: '',
            max_budget: ''
        });
        setSearchTerm('');
        handleCloseOptions();
    };

    const applyFilters = () => {
        handleCloseOptions();
    };

    const handlefilterOptions = () => setFilterOptions(true);
    const handleCloseOptions = () => setFilterOptions(false);
    const handleCloseView = () => setOpenView(false);
    const handleOpenView = (record) => {
        setSelectedRecord(record);
        setOpenView(true);
    };

    // Dialog handlers
    const handleOpenAdd = () => {
        if (!hasPermission('ADD')) {
            showToast("Permission Denied", "You don't have permission to add expense categories", "error");
            return;
        }

        setPostStatus("ADD");
        setFormData({
            category_name: '',
            budget_monthly: '',
            notes: '',
            is_active: true,
            color_code: '#3498db',
            icon_name: 'Category'
        });
        setErrors({
            category_name: false
        });
        setOpenAdd(true);
    };

    const handleCloseAdd = () => {
        setOpenAdd(false);
    };

    const handleOpenEdit = (record) => {
        if (!hasPermission('EDIT')) {
            showToast("Permission Denied", "You don't have permission to edit expense categories", "error");
            return;
        }

        setSelectedRecord(record);
        setUpdateId(record.id);
        setPostStatus("UPDATE");

        setFormData({
            category_name: record.category_name || '',
            budget_monthly: record.budget_monthly || '',
            notes: record.notes || '',
            is_active: record.is_active || false,
            color_code: record.color_code || '#3498db',
            icon_name: record.icon_name || 'Category'
        });
        setOpenAdd(true);
    };

    const handleOpenDelete = (record) => {
        if (!hasPermission('DELETE')) {
            showToast("Permission Denied", "You don't have permission to delete expense categories", "error");
            return;
        }

        setSelectedRecord(record);
        setUpdateId(record.id);
        setPostStatus("DELETE");
        setOpenDelete(true);
    };

    const handleCloseDelete = () => {
        setOpenDelete(false);
    };

    // Form handlers
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        setErrors(prev => ({
            ...prev,
            [name]: false
        }));

        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const validateForm = () => {
        if (!formData.category_name) {
            showToast("Validation Error", "Category name is required", "warning");
            return false;
        }
        if (formData.budget_monthly && (formData.budget_monthly < 0 || isNaN(formData.budget_monthly))) {
            showToast("Validation Error", "Budget monthly must be a positive number", "warning");
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (postStatus === "ADD" && !hasPermission('ADD')) {
            showToast("Permission Denied", "You don't have permission to add expense categories", "error");
            return;
        }
        
        if (postStatus === "UPDATE" && !hasPermission('EDIT')) {
            showToast("Permission Denied", "You don't have permission to update expense categories", "error");
            return;
        }
        
        if (postStatus === "DELETE" && !hasPermission('DELETE')) {
            showToast("Permission Denied", "You don't have permission to delete expense categories", "error");
            return;
        }
        
        if (postStatus !== "DELETE") {
            if (!validateForm()) return;
        }

        const formDataToSend = new FormData();
        formDataToSend.append('user_id', getUserDetails("Id"));
        formDataToSend.append('branch_id', getUserDetails("branchId"));

        if (postStatus !== "DELETE") {
            formDataToSend.append('category_name', formData.category_name);
            formDataToSend.append('budget_monthly', formData.budget_monthly || 0);
            formDataToSend.append('notes', formData.notes || '');
            formDataToSend.append('is_active', formData.is_active ? 1 : 0);
            formDataToSend.append('color_code', formData.color_code);
            formDataToSend.append('icon_name', formData.icon_name);
        }

        if (postStatus === "UPDATE" || postStatus === "DELETE") {
            formDataToSend.append('updateId', updateId);
        }

        try {
            let result;
            if (postStatus === "ADD") {
                result = await apiService.create(APIExpenseCategoryStore, formDataToSend);
            } else if (postStatus === "UPDATE") {
                result = await apiService.update(APIExpenseCategoryUpdate, formDataToSend);
            } else if (postStatus === "DELETE") {
                result = await apiService.delete(APIExpenseCategoryDelete, formDataToSend);
            }

            if (result && result.success && isMounted.current) {
                showToast("Success", result.message, "success");
                handleCloseAdd();
                handleCloseDelete();
                fetchCategories();
            }
        } catch (error) {
            console.error("API Error:", error);
            if (isMounted.current) {
                showToast("Error", error.response?.data?.message || "Operation failed", "error");
            }
        }
    };


    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-UG', {
            style: 'currency',
            currency: 'UGX',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount || 0);
    };

    // Filtered data
    const filteredData = useMemo(() => {
        return pageState.pageData.filter(record => {
            const matchesSearch = searchTerm === '' ||
                record.category_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                record.notes?.toLowerCase().includes(searchTerm.toLowerCase());

            const matchesCategory = !filters.category_name || 
                record.category_name?.toLowerCase().includes(filters.category_name.toLowerCase());

            const matchesActive = filters.is_active === '' || 
                (filters.is_active === 'active' ? record.is_active : !record.is_active);

            const matchesMinBudget = !filters.min_budget ||
                (record.budget_monthly && record.budget_monthly >= parseFloat(filters.min_budget));
            const matchesMaxBudget = !filters.max_budget ||
                (record.budget_monthly && record.budget_monthly <= parseFloat(filters.max_budget));

            return matchesSearch && matchesCategory && matchesActive && matchesMinBudget && matchesMaxBudget;
        });
    }, [pageState.pageData, searchTerm, filters]);

    // Pagination
    const handleChangePage = (event, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    if (permissionLoading) {
        return <LoadingState message="Loading permissions..." variant="medical" size="large" fullPage />;
    }

    if (loading) {
        return <LoadingState message="Loading Expense Categories..." variant="medical" size="large" fullPage />;
    }

    if (error) {
        return <ErrorState error={error} onRetry={fetchCategories} title="Unable to Load Expense Categories" variant="medical" fullPage retryText="Retry Loading" />;
    }

    return (
        <Container maxWidth="xl" sx={{ py: 3 }}>
            {/* Action Buttons */}
            <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, flexShrink: 0 }}>
                        Expense Categories ({recordsCount(pageState.pageData.length)} Total)
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
                        {hasPermission('ADD') && (
                            <Button
                                variant="contained"
                                color="warning"
                                startIcon={<AddIcon />}
                                onClick={handleOpenAdd}
                                sx={{ textTransform: 'none', borderRadius: '8px' }}
                            >
                                Add Category
                            </Button>
                        )}
                        {hasPermission('VIEW') && (
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<FilterIcon />}
                                onClick={handlefilterOptions}
                                sx={{ textTransform: 'none', borderRadius: '8px' }}
                            >
                                View Options
                            </Button>
                        )}
                        {hasPermission('EXPORT') && (
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<GetApp />}
                                onClick={handleExportClick}
                                sx={{ textTransform: 'none', borderRadius: '8px' }}
                            >
                                Export Data
                            </Button>
                        )}
                        <Button
                            variant="outlined"
                            color="info"
                            startIcon={<RefreshIcon />}
                            onClick={() => { fetchCategories(); }}
                            sx={{ textTransform: 'none', borderRadius: '8px' }}
                        >
                            Refresh
                        </Button>
                    </Box>

                    <Paper sx={{
                        width: '300px',
                        p: '2px 8px',
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: 'auto',
                        borderRadius: '8px',
                        background: theme.palette.primary.light
                    }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Search categories..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            InputProps={{
                                startAdornment: <Search sx={{ mr: 1, color: 'white' }} />,
                                sx: {
                                    '& fieldset': { border: 'none' },
                                    fontSize: '0.875rem',
                                    color: 'white',
                                    '& input': { color: 'white', '&::placeholder': { color: 'rgba(255,255,255,0.7)', opacity: 1 } }
                                }
                            }}
                            size="small"
                        />
                    </Paper>
                </Box>
            </Paper>

            {/* Export Menu */}
            <Menu anchorEl={exportAnchorEl} open={Boolean(exportAnchorEl)} onClose={handleExportClose}>
                <MenuItem onClick={handleExportExcel} sx={{ gap: 1 }}><TableChart fontSize="small" color="success" /> Export to Excel (.xlsx)</MenuItem>
                <MenuItem onClick={handleExportPDF} sx={{ gap: 1 }}><PictureAsPdf fontSize="small" color="error" /> Export to PDF (.pdf)</MenuItem>
            </Menu>

            {/* Categories Table */}
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
                <Paper elevation={2} sx={{ borderRadius: 3, overflow: 'hidden' }}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: theme.palette.primary.main, '& th': { color: 'white', fontWeight: 'bold', fontSize: '0.95rem' } }}>
                                    <TableCell>#</TableCell>
                                    <TableCell>Category Name</TableCell>
                                    <TableCell>Monthly Budget (UGX)</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Created Date</TableCell>
                                    <TableCell align="center">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((record, index) => (
                                    <TableRow key={record.id || index} hover sx={{ '&:nth-of-type(odd)': { backgroundColor: theme.palette.action.hover } }}>
                                        <TableCell><Chip label={page * rowsPerPage + index + 1} color="primary" size="small" /></TableCell>
                                        <TableCell>
                                                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                                    {record.category_name}
                                                </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2" sx={{ fontWeight: 'bold', color: theme.palette.success.main }}>
                                                {formatCurrency(record.budget_monthly)}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                icon={record.is_active ? <CheckCircle /> : <Cancel />}
                                                label={record.is_active ? 'Active' : 'Inactive'}
                                                color={record.is_active ? 'success' : 'default'}
                                                size="small"
                                            />
                                        </TableCell>
                                        <TableCell>{formatCreatedAtDate(record.created_at)}</TableCell>
                                        <TableCell align="center">
                                            {hasPermission('VIEW') && (
                                                <Tooltip title="View Details"><IconButton onClick={() => handleOpenView(record)} color="primary"><ViewIcon /></IconButton></Tooltip>
                                            )}
                                            {hasPermission('PRINT') && (
                                                <Tooltip title="Print"><IconButton onClick={() => handlePrintCategory(record)} color="info"><PrintIcon /></IconButton></Tooltip>
                                            )}
                                            {hasPermission('EDIT') && (
                                                <Tooltip title="Edit"><IconButton onClick={() => handleOpenEdit(record)} color="secondary"><EditIcon /></IconButton></Tooltip>
                                            )}
                                            {hasPermission('DELETE') && (
                                                <Tooltip title="Delete"><IconButton onClick={() => handleOpenDelete(record)} color="error"><Delete /></IconButton></Tooltip>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination rowsPerPageOptions={[5, 10, 25, 50, 100]} component="div" count={filteredData.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} sx={{ mt: 2 }} />
                    {filteredData.length === 0 && (
                        <Box sx={{ textAlign: 'center', py: 8, color: 'text.secondary' }}>
                            <Category sx={{ fontSize: 60, mb: 2 }} />
                            <Typography variant="h6">No expense categories found</Typography>
                            <Typography variant="body2">Click "Add Category" to create one</Typography>
                        </Box>
                    )}
                </Paper>
            </motion.div>

            {/* Filter Dialog - Prevent click outside */}
            <Dialog
                open={filterOptions}
                TransitionComponent={Transition}
                fullWidth
                maxWidth="sm"
                disableEscapeKeyDown
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseOptions();
                    }
                }}
            >
                <DialogTitle sx={{ textAlign: 'center' }}>Filter Options</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, p: 2 }}>
                        <Button variant="outlined" color="primary" startIcon={<RefreshIcon />} onClick={clearFilters}>Show All Categories</Button>
                        <Divider>OR</Divider>
                        <Typography variant="subtitle1" sx={{ textAlign: 'center' }}>Filter Categories</Typography>
                        <Box>
                            <Grid item xs={12}>
                                <TextField fullWidth label="Category Name" name="category_name" value={filters.category_name} onChange={handleFilterChange} placeholder="Search by name" />
                            </Grid><br/>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Status</InputLabel>
                                    <Select name="is_active" value={filters.is_active} onChange={handleFilterChange} label="Status">
                                        <MenuItem value="">All</MenuItem>
                                        <MenuItem value="active">Active</MenuItem>
                                        <MenuItem value="inactive">Inactive</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Min Budget (UGX)" name="min_budget" type="number" value={filters.min_budget} onChange={handleFilterChange} placeholder="Min amount" />
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Max Budget (UGX)" name="max_budget" type="number" value={filters.max_budget} onChange={handleFilterChange} placeholder="Max amount" />
                            </Grid>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={handleCloseOptions} variant="contained">Close</Button>
                    <Button onClick={applyFilters} color="primary" variant="contained">Apply Filters</Button>
                </DialogActions>
            </Dialog>

            {/* Add/Edit Category Dialog - Prevent click outside */}
            <Dialog
                open={openAdd}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseAdd();
                    }
                }}
                TransitionComponent={Transition}
                fullWidth
                maxWidth="sm"
                disableEscapeKeyDown
            >
                <DialogTitle sx={{ textAlign: 'center' }}><b>{postStatus === "ADD" ? "Add Expense Category" : "Edit Expense Category"}</b></DialogTitle>
                <DialogContent>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                        <Box>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}>Category Information</Typography>
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Category Name"
                                    name="category_name"
                                    value={formData.category_name}
                                    onChange={handleInputChange}
                                    required
                                    error={errors.category_name}
                                    helperText={errors.category_name ? "Category name is required" : ""}
                                />
                            </Grid>

                            <br/>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Monthly Budget (UGX)"
                                    name="budget_monthly"
                                    type="number"
                                    value={formData.budget_monthly}
                                    onChange={handleInputChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <AttachMoney />
                                            </InputAdornment>
                                        ),
                                    }}
                                    helperText="Optional - Set a monthly budget limit for this category"
                                />
                            </Grid>
                            <br/>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Notes"
                                    name="notes"
                                    value={formData.notes}
                                    onChange={handleInputChange}
                                    multiline
                                    rows={3}
                                    placeholder="Additional notes about this expense category..."
                                />
                            </Grid>
                            <br/>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={<Switch name="is_active" checked={formData.is_active} onChange={handleInputChange} color="primary" />}
                                    label="Active"
                                />
                            </Grid>
                        </Box>
                        <DialogActions sx={{ mt: 3, px: 0 }}>
                            <Button color="error" onClick={handleCloseAdd} variant="contained">Cancel</Button>
                            <Button type="submit" color="primary" variant="contained">{postStatus === "ADD" ? "Create Category" : "Update Category"}</Button>
                        </DialogActions>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* View Dialog - Prevent click outside */}
            <Dialog
                open={openView}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseView();
                    }
                }}
                TransitionComponent={Transition}
                fullWidth
                maxWidth="sm"
                disableEscapeKeyDown
            >
                <DialogTitle sx={{ textAlign: 'center' }}><b>Category Details</b></DialogTitle>
                <DialogContent>
                    {selectedRecord && (
                        <Box sx={{ p: 2 }}>
                            <Box>
                                <Grid item xs={12}>
                                        <Typography variant="h6" color="primary">
                                            {selectedRecord.category_name}
                                        </Typography>
                                </Grid>
                                <br/>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2"><b>Monthly Budget:</b> {formatCurrency(selectedRecord.budget_monthly)}</Typography>
                                </Grid>
                                <br/>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2"><b>Status:</b> 
                                        <Chip
                                            icon={selectedRecord.is_active ? <CheckCircle /> : <Cancel />}
                                            label={selectedRecord.is_active ? 'Active' : 'Inactive'}
                                            color={selectedRecord.is_active ? 'success' : 'default'}
                                            size="small"
                                            sx={{ ml: 1 }}
                                        />
                                    </Typography>
                                </Grid>
                                <br/>
                                {selectedRecord.notes && (
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle2"><b>Notes:</b> {selectedRecord.notes}</Typography>
                                    </Grid>
                                )}
                                <Grid item xs={12}>
                                    <Typography variant="h6" color="primary" sx={{ mt: 2 }}>System Information</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2"><b>Created:</b> {formatCreatedAtDate(selectedRecord.created_at)}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2"><b>Last Updated:</b> {formatCreatedAtDate(selectedRecord.updated_at)}</Typography>
                                </Grid>
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={handleCloseView} variant="contained">Close</Button>
                    {hasPermission('PRINT') && selectedRecord && <Button onClick={() => handlePrintCategory(selectedRecord)} color="info" variant="contained"><PrintIcon sx={{ mr: 1 }} /> Print</Button>}
                </DialogActions>
            </Dialog>

            {/* Delete Confirmation Dialog - Prevent click outside */}
            <Dialog
                open={openDelete}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseDelete();
                    }
                }}
                TransitionComponent={Transition}
                disableEscapeKeyDown
            >
                <DialogTitle sx={{ textAlign: 'center' }}>Delete Expense Category</DialogTitle>
                <DialogContent>
                    <Typography variant="body1" sx={{ textAlign: 'center', mb: 2 }}>Are you sure you want to delete this expense category?</Typography>
                    {selectedRecord && (
                        <Typography variant="h6" sx={{ textAlign: 'center' }}>
                            {selectedRecord.category_name}
                            <Box sx={{ mt: 2 }}>
                                <Chip
                                    icon={selectedRecord.is_active ? <CheckCircle /> : <Cancel />}
                                    label={selectedRecord.is_active ? 'Active' : 'Inactive'}
                                    color={selectedRecord.is_active ? 'success' : 'default'}
                                    size="small"
                                />
                            </Box>
                        </Typography>
                    )}
                    <Typography variant="body2" color="error" sx={{ textAlign: 'center', mt: 2 }}>Warning: This action cannot be undone!</Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={handleCloseDelete} variant="contained">Cancel</Button>
                    <Button onClick={handleSubmit} color="primary" variant="contained">Confirm Delete</Button>
                </DialogActions>
            </Dialog>

            <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
                <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>{snackbar.message}</Alert>
            </Snackbar>
        </Container>
    );
};

export default ExpenseCategory;